import React, { useEffect, useState } from "react";
import "style_v2/v2_app.scss";
import { getPathNames, RATING_SCALES, ROUTER_OBJECT, TEMPLATES, CUSTOM_FORMS, MANAGER, SETTINGS, STORE } from "config/helpers/router_helper_v2";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import i18n from "multilingual";
import { ManageIcon, TemplateIcon } from "assets/icons/NavIcons";
import SummarizeIcon from '@mui/icons-material/Summarize';
import useIsEnterpriseOrg from "hooks/useIsEnterpriseOrg";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useSelector((state) => state?.app.theme);
  const userRoles = useSelector((state) => state?.auth?.userRoles);
  const isAdmin = userRoles?.some((r) => r.code === "admin" && r.is_active);
  const isEnterpriseOrg = useIsEnterpriseOrg();
  const [isActive, setIsActive] = useState(false);
  const [currentLabel, setCurrentLabel] = useState(() => {
    if (_.capitalize(getPathNames()[1]) === "Home") return "Dashboard";
    return _.capitalize(getPathNames()[1]);
  });

  const [routerObject, setRouterObject] = useState(ROUTER_OBJECT);

  useEffect(() => {
    const ratingScaleRouter = [
      // {
      //   label: "Intake-forms",
      //   Icon: SummarizeIcon,
      //   identifier: RATING_SCALES,
      //   path: "/intake",
      // },
      {
        label: "Notes & Scales",
        Icon: TemplateIcon,
        identifier: CUSTOM_FORMS,
        path: "/customForms",
      },
      // {
      //   label: "Form-Scales",
      //   Icon: SummarizeIcon,
      //   identifier: RATING_SCALES,
      //   path: "/form",
      // },

    ];

    const baseRoutes = [...ROUTER_OBJECT];

    // Insert each route before the last item
    baseRoutes.splice(baseRoutes.length - 1, 0, ...ratingScaleRouter);

    setRouterObject(baseRoutes);
  }, []);


  return (
    <>
      <style>
        {`.active-mobile{
            border-radius: 0 0 10px 10px;
            position: relative;
          } 

          .active-mobile::before{
            position: absolute;
            content: "";
            width: 40px;
            height: 12px;
            background: transparent;
            right: calc(50% + 4px);
            top: -1px;
            border-top-right-radius: 12px;
            box-shadow: 10px 0 0 ${theme === "dark" ? "#fff" : "#5D5FEF"};
          }
          .active-mobile::after{
            position: absolute;
            content: "";
            width: 40px;
            height: 12px;
            background: transparent;
            left: calc(50% + 4px);
            bottom: calc(100% - 11px);
            border-top-left-radius: 12px;
            box-shadow: -10px 0 0 ${theme === "dark" ? "#fff" : "#5D5FEF"};
          }`}
      </style>
      <div
        style={{
          backgroundColor: theme === "dark" ? "#2C2F48" : "white",
          zIndex: "999",
          height: "10dvh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          // className="bg-white"
          style={{
            fontSize: "1.3vh",
            color: theme === "dark" ? "#2C2F48" : "white",
            textAlign: "center",
            backgroundColor: theme === "dark" ? "white" : "#5D5FEF"
          }}
        >
          {/* {label} */}
          {i18n.t(`Side_Menu.${currentLabel}`)}
        </div>
        <div
          className="d-flex flex-row justify-content-around w-100"
          style={{ padding: "0 5vw 1vw", height: "100%", marginTop: "-1px" }}
        >
          {(isAdmin
            ? [
                { label: "Manager", Icon: ManageIcon, identifier: MANAGER, path: "/manager/users" },
                ...routerObject.filter(
                  (item) => item.identifier === SETTINGS || (item.identifier === STORE && isEnterpriseOrg)
                ),
              ]
            : routerObject.filter(
                (item) => item.identifier !== MANAGER && !(item.identifier === STORE && isEnterpriseOrg)
              )
          )
            .map(({ label, Icon, path, identifier }) => {
            const isActiveOption =
              getPathNames()[1] === _.lowerCase(identifier) || location.pathname.includes(path);

            return (
              <div
                key={identifier}
                onClick={() => {
                  if (location.pathname !== path) {
                    navigate(path);
                    setIsActive(isActiveOption);
                    setCurrentLabel(label);
                  }
                }}
                className={`d-flex flex-column align-items-center cursor-pointer ${isActiveOption
                  ? `active-mobile`
                  : "text-white bg-transparent"
                  }`}
                style={{ width: "18vw", position: "relative", backgroundColor: theme === "dark" ? isActiveOption ? "white" : "#2C2F48" : isActiveOption ? "#5D5FEF" : "transparent" }}
              >
                <div
                  className="rounded-lg p-2"
                  style={{ margin: "auto" }}
                // style={{ color: theme === "dark" ? isActiveOption ? "#2C2F48" : "white" : isActiveOption ? "white" : "#2C2F48" }}
                >
                  <Icon
                    sx={
                      {
                        // fontSize: "1.5rem",
                        color: theme === "dark" ? isActiveOption ? "#2C2F48" : "white" : isActiveOption ? "white" : "#5D5FEF"
                      }
                    }
                    isSelected={isActiveOption}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BottomNav;
